import {Component, ElementRef, OnInit, QueryList, ViewChildren} from '@angular/core';
import {NgClass, NgForOf, NgIf, NgStyle} from "@angular/common";
import {Apollo} from "apollo-angular";
import {getAllCategorias, getAllPromocionesMongoFront} from "../../../graphql/graphql.queris";
import {RouterLink} from "@angular/router";
import {environment} from "../../../../environments/environment";
import {PromotionPersonService} from "../services/promotion-person.service";
import {Observable} from "rxjs";

@Component({
  selector: 'app-promotions-list',
  standalone: true,
  imports: [
    NgForOf,
    NgIf,
    RouterLink,
    NgStyle,
    NgClass
  ],
  templateUrl: './promotions-list.component.html',
  styleUrl: './promotions-list.component.css'
})
export class PromotionsListComponent implements OnInit {
  @ViewChildren('elemento', { read: ElementRef }) elementos!: QueryList<ElementRef>;

  promotions: any[] = [];
  categorias: any[] = [];
  promotionsVisibles: any[] = [];
  todasLasPromotions: any[] = []; // Guardamos todas las promociones sin filtrar
  promotionsPorPagina = 50;
  paginaActual = 1;
  loading = true;
  error: any;
  serverImgenUrl = environment.imgUrl;

  constructor(
    private apollo: Apollo,
    private promotionPersonService: PromotionPersonService
  ) {}

  ngOnInit(): void {
    // Obtener todas las promociones
    this.getAllPromociones();
    this.getAllCategorias();
  }


  getAllPromociones() {
    this.promotionPersonService.getAllPromociones().subscribe({
      next: (promotions) => {
        this.promotions = promotions;
        this.promotions.sort((a, b) => {
          return  new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime() ;
        });
        this.todasLasPromotions = [...promotions];
        this.cargarMas();
        this.loading = false;
      },
      error: (err) => {
        this.error = err;
        this.loading = false;
      }
    });
  }


  getAllCategorias() {
    this.promotionPersonService.getAllCategorias().subscribe({
      next: (categorias) => {
        // Ordenar alfabéticamente por nombre o por el campo deseado
        this.categorias = categorias.sort((a: any, b: any) => {
          const nombreA = a.categoria;
          const nombreB = b.categoria;
          return nombreA.localeCompare(nombreB);
        });
      },
      error: (err) => {
        this.error = err;
        this.loading = false;
      }
    });
  }



  filtroByCategoria(categoria: string): void {
    this.promotionPersonService.filtroByCategoria(categoria).subscribe({
      next: (filteredPromotions) => {
        this.promotionsVisibles = filteredPromotions;
      },
      error: (err) => {
        this.error = err;
      }
    });
  }

  showAll() {
    this.promotionsVisibles = [...this.todasLasPromotions];
  }


  cargarMas(): void {
    const inicio = (this.paginaActual - 1) * this.promotionsPorPagina;
    const fin = this.paginaActual * this.promotionsPorPagina;
    this.promotionsVisibles = this.promotionsVisibles.concat(this.promotions.slice(inicio, fin));
    this.paginaActual++;
  }

  convertirPrimeraLetraMayuscula(texto: string): string {
    return texto.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
  }

}
